var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalenderwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99982 0.25C4.41403 0.25 4.74982 0.585786 4.74982 1V2.66763C7.57755 2.4158 10.4221 2.4158 13.2498 2.66763V1C13.2498 0.585786 13.5856 0.25 13.9998 0.25C14.414 0.25 14.7498 0.585786 14.7498 1V2.81644C16.2429 3.02754 17.4224 4.20847 17.6221 5.71484L17.7086 6.36779C18.0726 9.11412 18.0412 11.8984 17.6152 14.6359C17.4042 15.9919 16.3026 17.0335 14.9368 17.1681L13.7438 17.2858C10.5888 17.5969 7.41079 17.5969 4.25574 17.2858L3.06274 17.1681C1.697 17.0335 0.595338 15.9919 0.384328 14.6359C-0.0416297 11.8984 -0.0730704 9.11412 0.290965 6.36779L0.377517 5.71484C0.577193 4.20845 1.75674 3.02751 3.24982 2.81643V1C3.24982 0.585786 3.5856 0.25 3.99982 0.25ZM4.44498 4.2028C7.47417 3.90408 10.5254 3.90408 13.5546 4.2028L14.46 4.2921C15.3268 4.37757 16.0206 5.04854 16.1351 5.91194L16.2216 6.56489C16.2519 6.793 16.2792 7.02139 16.3037 7.25H1.69588C1.72036 7.02139 1.74772 6.79301 1.77796 6.5649L1.86451 5.91194C1.97896 5.04854 2.67278 4.37757 3.53953 4.2921L4.44498 4.2028ZM1.57665 8.75C1.47847 10.6381 1.5752 12.5332 1.86649 14.4052C1.97233 15.0854 2.52491 15.6078 3.20995 15.6754L4.40295 15.793C7.46009 16.0945 10.5395 16.0945 13.5966 15.793L14.7896 15.6754C15.4747 15.6078 16.0272 15.0854 16.1331 14.4052C16.4244 12.5332 16.5211 10.6381 16.4229 8.75H1.57665Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderwhite);
export default __webpack_public_path__ + "static/media/calenderwhite.61fb744df3be15a49d53d34c1f491c32.svg";
export { ForwardRef as ReactComponent };